import Env from "../runtimeEnv";

const PROTOCOL_VERSION = 1;

export function isNativeMobileShell() {
  return window.__PLUTONIC_NATIVE_SHELL__ === true || Boolean(window.PlutonicNative);
}

export function getNativeAppVersion() {
  if (typeof window.PlutonicNative?.getAppVersion === "function") {
    return window.PlutonicNative.getAppVersion();
  }

  return window.__PLUTONIC_APP_VERSION__ || null;
}

export function getNativeDeviceCapabilities() {
  if (typeof window.PlutonicNative?.getDeviceCapabilities === "function") {
    try {
      return JSON.parse(window.PlutonicNative.getDeviceCapabilities());
    } catch (error) {
      console.warn("Unable to read native device capabilities");
    }
  }

  return null;
}

export function exportNativeDiagnosticLogs() {
  if (
    !isNativeMobileShell() ||
    typeof window.PlutonicNative?.exportDiagnosticLogs !== "function"
  ) {
    return false;
  }

  window.PlutonicNative.exportDiagnosticLogs();
  return true;
}

export function launchNativeUnitySession({
  roomId,
  sessionId,
  userId,
  displayName,
  userType,
  demoBuild = false,
}) {
  if (!isNativeMobileShell()) return false;

  if (sessionId && userId) {
    fetch(`${Env.REACT_APP_PYTHON_API_URL}/api/meeting-join-context/${userId}`, {
      method: "POST",
      keepalive: true,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ meetingID: sessionId, joinDevice: "mobile" }),
    }).catch(() => {});
  }

  const message = {
    type: "JOIN_UNITY_SESSION",
    protocolVersion: PROTOCOL_VERSION,
    payload: {
      roomId,
      sessionId,
      userId,
      displayName,
      userType,
      demoBuild,
    },
  };

  window.dispatchEvent(new Event("plutonic-unity-start"));
  if (typeof window.__plutonicJoinSession === "function") {
    window.__plutonicJoinSession(JSON.stringify(message));
  } else {
    window.PlutonicNative.joinSession(JSON.stringify(message));
  }
  return true;
}
